"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapPageElement = void 0;

var _react = _interopRequireDefault(require("react"));

var _pageContext = require("./page-context");

var _pageSeo = require("./page-seo");

var wrapPageElement = function wrapPageElement(_ref) {
  var element = _ref.element,
      props = _ref.props;
  var pageContext = props.pageContext;
  return /*#__PURE__*/_react.default.createElement(_pageContext.PageContextProvider, {
    pageContext: pageContext
  }, /*#__PURE__*/_react.default.createElement(_pageSeo.PageSEO, null), element);
};

exports.wrapPageElement = wrapPageElement;